import React from 'react'
import cx from 'classnames'

import Modal from 'components/Modal/Modal'

import s from './HeroModal.scss'


const HeroModal = ({ children, className, onClose }) => (
  <Modal
    className={cx(s.heroModal, className)}
    onClose={onClose}
  >
    <div>
      {children}
    </div>
  </Modal>
)


export default HeroModal
